import styled from "styled-components"

import { minWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import CroppedImage from "components/cropped-image"
import GeneralCard from "../base"
import { Headline } from "../base/styles"

export const Container = styled.div`
  position: relative;
  margin-right: 1.2rem;

  ${minWidth.hamburgerLarge`
    margin-right: 0;
  `}
`

export const StyledCard = styled(GeneralCard)`
  margin: 0;

  .card-header {
    padding: 0;
  }
`

export const ImageRegular = styled(CloudinaryImage)`
  padding-bottom: calc(154 / 200 * 100%);

  ${minWidth.hamburgerLarge`
    padding-bottom: calc(184 / 239 * 100%);
  `}
`

export const ImageCropped = styled(CroppedImage)`
  padding-bottom: calc(154 / 200 * 100%);

  ${minWidth.hamburgerLarge`
    padding-bottom: calc(184 / 239 * 100%);
  `}
`

export const HeadlineWord = styled.span`
  display: block;
  width: fit-content;
  padding: 0.5rem 0.5rem 0.2rem 0.5rem;
  margin: 0 0 0.3rem 0;
  background-color: #fff;
  color: #222;
  overflow-wrap: break-word;
  hyphens: auto;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
`

const BaseHeadline = styled(Headline)`
  position: absolute;
  z-index: 3;
  max-width: calc(20rem - 1.8rem - 1.8rem);
  font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;

  ${minWidth.hamburgerLarge`
    max-width: calc(23.9rem - 1.8rem - 1.8rem);
    font-size: 2.867rem;
  `}
`

export const NavigationHeadline = styled(BaseHeadline)`
  left: 2rem;
  bottom: 1.4rem;
  padding: 0;
  font-size: 2.2rem;
  line-height: 1;
  background: none;

  ${minWidth.hamburgerLarge`
    bottom: 2.8rem;
    font-size: 2.867rem;
  `}
`

export const ImageHeadline = styled(BaseHeadline)`
  left: 1.8rem;
  bottom: 2.5rem;
  width: fit-content;
  padding: 0.5rem 0.5rem 0 0.5rem;
  background-color: #fff;
  color: #222;
  font-size: 2.4rem;
  line-height: 3.24rem;

  ${minWidth.hamburgerLarge`
    font-size: 2.867rem;
    line-height: 3.87rem;
  `}
`
